import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Everyone: 'Everyone',
  SingleAllowedUser: '1 user',
  AllowedUserCount: '{count} users',
  AllowedUsers: 'Allowed users',
  EnterTag: 'Enter tag',
  Color: 'Color',
  ColorGrey: 'Grey',
  ColorBlue: 'Blue',
  ColorYellow: 'Yellow',
  ColorOrange: 'Orange',
  ColorRed: 'Red',
  ColorGreen: 'Green',
  Name: 'Name',
  ShowOnRegistration: 'Show on registration',
  NrOfRelations: 'Nr of relations',
  NrOfDocuments: 'Nr of documents',
  NrOfEmployees: 'Nr of employees',
  Actions: 'Actions',
  DeleteDocumentTag: 'Delete tag?',
  DeleteDocumentTagConfirmationMsg:
    'This tag is linked to documents. By removing this tag, you also remove it from the documents. Are you sure you want to delete this tag?',
  AddTag: 'Add tag',
  TagAlreadyExists: 'This tag already exists',
  DocumentTags: 'Document tags',
  DocumentTypes: 'Document types',
  TaskTags: 'Task tags',
  RelationTags: 'Relation tags',
  ApplyToDocumentTypes: 'Apply to document types',
  ChangesSaved: 'Changes saved',
  SetIsPublicOnPortal: 'Is public on portal',
  SetIsPublicOnPortalExplanation:
    'If this option is enabled, all documents that are recognized by AdminPulse and are given the selected label, will also be automatically made public on the portal.',
  InteractionTags: 'Interaction tags',
  DeleteInteractionTagConfirmationMsg:
    'By removing this tag, you also remove it from the interactions. Are you sure you want to delete this tag?',
  DeleteTag: 'Delete tag?',
  DeleteRelationTagConfirmationMsg:
    'This tag is linked to relations. By removing this tag, you also remove it from the relations. Are you sure you want to delete this tag?',
  DeleteTaskTagConfirmationMsg:
    'By removing this tag, you also remove it from any linked tasks. Are you sure you want to delete this tag?',
  DeleteEmployeeTagConfirmationMsg:
    'This tag is linked to employees. By removing this tag, you also remove it from the employees. Are you sure you want to delete this tag?',
  RelationGroups: 'Relation groups',
  AddRelationGroup: 'Add relation group',
  DeleteRelationGroup: 'Delete relation group',
  DeleteRelationGroupConfirmationMsg:
    'This group is linked to relations. By removing this relation group, you also remove it from the relations. Are you sure you want to delete this group?',
  RelationGroupAlreadyExists: 'This relation group already exists',
  EmployeeTags: 'Employee tags',
  CreditNoteReasons: 'Credit note reasons',
  AddCreditNoteReason: 'Add credit note reason',
  EnterCreditNoteReason: 'Enter reason',
  DeleteCreditNoteReason: 'Delete credit note reason?',
  DeleteCreditNoteReasonConfirmationMsg: 'Are you sure you want to delete this credit note reason?',
  CreditNoteReasonAlreadyExists: 'This credit note reason already exists',
  CreditNoteReasonInUse:
    'This reason is used on credit notes and cannot be deleted. Disable it instead so it can no longer be selected.',
  NrOfCreditNotes: 'Nr of credit notes',
  Disabled: 'Disabled',
});
export default messages;
